import script from "./GrantCourtesyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GrantCourtesyModal.vue?vue&type=script&setup=true&lang=js"

import "./GrantCourtesyModal.vue?vue&type=style&index=0&id=2e84d641&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e84d641"]])

export default __exports__